import { createAction } from 'redux-act';

export const sendCalculatorInfo = createAction('Send Calculator Info');
